import type { AutoAnimationPlugin } from '@formkit/auto-animate';

const duration = 250;

export const verticalFieldAnimation: AutoAnimationPlugin = (element, action, coordsA, coordsB) => {
  if (action === 'add') {
    return new KeyframeEffect(
      element,
      [
        { opacity: 0, transform: 'scale(0.98)' },
        { offset: 0.5, opacity: 0, transform: 'scale(0.98)' },
        { opacity: 1, transform: 'scale(1)' },
      ],
      { duration: duration * 1.5, easing: 'ease-in' },
    );
  }

  if (action === 'remove') {
    return new KeyframeEffect(
      element,
      [
        { opacity: 1, transform: 'scale(1)' },
        { opacity: 0, transform: 'scale(0.98)' },
      ],
      { duration, easing: 'ease-out' },
    );
  }

  const oldCoords = coordsA;
  const newCoords = coordsB;

  const deltaBottom = oldCoords && newCoords ? oldCoords.top + oldCoords.height - (newCoords.top + newCoords.height) : 0;
  const deltaTop = !oldCoords || !newCoords || deltaBottom === 0 ? 0 : oldCoords.top - newCoords.top;

  return new KeyframeEffect(element, [{ transform: `translateY(${deltaTop}px)` }, { transform: 'translateY(0)' }], {
    duration,
    easing: 'ease-in-out',
  });
};
